import React from 'react';
import { ChannelEditTemplate } from 'themes/modules/channel/pages';
import { setCurrentView } from 'core/utils';
import { ChannelEditViewStore } from 'modules/channel/stores';

@setCurrentView(rootStore => new ChannelEditViewStore(rootStore), 'channelEditViewStore')
class ChannelEdit extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ChannelEditTemplate {...this.props} />;
	}
}

export default ChannelEdit;
